/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CourtInputs */

const th_court = /** @type {(inputs: CourtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สนาม`)
};

const en_court = /** @type {(inputs: CourtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Court`)
};

const ja_court = /** @type {(inputs: CourtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コート`)
};

const zh_court = /** @type {(inputs: CourtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球场`)
};

const es_court = /** @type {(inputs: CourtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pista`)
};

const pt_court = /** @type {(inputs: CourtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quadra`)
};

const id_court = /** @type {(inputs: CourtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lapangan`)
};

const fr_court = /** @type {(inputs: CourtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terrain`)
};

const tl_court = /** @type {(inputs: CourtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Court`)
};

const vi_court = /** @type {(inputs: CourtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sân`)
};

const ko_court = /** @type {(inputs: CourtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`코트`)
};

const de_court = /** @type {(inputs: CourtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feld`)
};

const ru_court = /** @type {(inputs: CourtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Площадка`)
};

const tr_court = /** @type {(inputs: CourtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saha`)
};

const it_court = /** @type {(inputs: CourtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campo`)
};

const pl_court = /** @type {(inputs: CourtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boisko`)
};

const uk_court = /** @type {(inputs: CourtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Майданчик`)
};

const hi_court = /** @type {(inputs: CourtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोर्ट`)
};

const ar_court = /** @type {(inputs: CourtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الملعب`)
};

const ms_court = /** @type {(inputs: CourtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gelanggang`)
};

const bn_court = /** @type {(inputs: CourtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কোর্ট`)
};

const zh_tw2_court = /** @type {(inputs: CourtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球場`)
};

const zh_hk2_court = /** @type {(inputs: CourtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球場`)
};

const ur_court = /** @type {(inputs: CourtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کورٹ`)
};

const fa_court = /** @type {(inputs: CourtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`زمین`)
};

const sw_court = /** @type {(inputs: CourtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiwanja`)
};

const nl_court = /** @type {(inputs: CourtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veld`)
};

/**
* | output |
* | --- |
* | "Court" |
*
* @param {CourtInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const court = /** @type {((inputs?: CourtInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CourtInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_court(inputs)
	if (locale === "ja") return ja_court(inputs)
	if (locale === "zh") return zh_court(inputs)
	if (locale === "es") return es_court(inputs)
	if (locale === "pt") return pt_court(inputs)
	if (locale === "id") return id_court(inputs)
	if (locale === "fr") return fr_court(inputs)
	if (locale === "tl") return tl_court(inputs)
	if (locale === "vi") return vi_court(inputs)
	if (locale === "ko") return ko_court(inputs)
	if (locale === "de") return de_court(inputs)
	if (locale === "ru") return ru_court(inputs)
	if (locale === "tr") return tr_court(inputs)
	if (locale === "it") return it_court(inputs)
	if (locale === "pl") return pl_court(inputs)
	if (locale === "uk") return uk_court(inputs)
	if (locale === "hi") return hi_court(inputs)
	if (locale === "ar") return ar_court(inputs)
	if (locale === "ms") return ms_court(inputs)
	if (locale === "bn") return bn_court(inputs)
	if (locale === "zh-TW") return zh_tw2_court(inputs)
	if (locale === "zh-HK") return zh_hk2_court(inputs)
	if (locale === "ur") return ur_court(inputs)
	if (locale === "fa") return fa_court(inputs)
	if (locale === "sw") return sw_court(inputs)
	if (locale === "nl") return nl_court(inputs)
	return en_court(inputs)
});